import { useCallback, useRef } from 'react';

import { Calendar } from 'primereact/calendar';

export const useStableCalendarOverlay = () => {
  const calendarRef = useRef<Calendar>(null);

  const onShow = useCallback(() => {
    const overlay = calendarRef.current?.getOverlay();

    if (overlay) {
      overlay.style.minHeight = `${overlay.offsetHeight}px`;
    }
  }, []);

  return { ref: calendarRef, onShow };
};
